import { useState } from 'react';

export const usePopup = (initialState = false) => {
  const [isOpen, setIsOpen] = useState(initialState);

  const openPopup = () => setIsOpen(true);
  const closePopup = () => setIsOpen(false);
  const togglePopup = () => setIsOpen(prev => !prev);

  return {
    isOpen,
    openPopup,
    closePopup,
    togglePopup,
  };
};
